import { Separator } from "@workspace/web-ui/components/separator";
import { Check } from "lucide-react";
import { currentMedicationRefills } from "../types";

interface CurrentRefills {
  currentRefillsItems: currentMedicationRefills[];
}

export function CurrentRefill({ currentRefillsItems }: CurrentRefills) {
  return (
    <div className=" w-full  bg-white shadow-md rounded-lg mb-4">
      <h2 className="text-lg font-semibold text-[#1A202C]  p-5">
        Currently Processing Medications
      </h2>
      <Separator />

      {currentRefillsItems.map((med, index) => (
        <div key={index} className="border-b py-6 px-6 last:border-none xs:overflow-scroll md:overscroll-none">
          <h3 className="text-md font-medium text-gray-900 mb-2">{med.name}</h3>
          <p className="text-sm text-gray-500">
            Ordered on {med.request_date} <span className="mx-2">{"\u2022"}</span>{" "}
            Delivered: {med.delivery_date}
          </p>

          {/* Status Steps */}
          <div className="w-full flex items-center justify-between space-x-2 mt-4">
            {med?.progress.map((step, idx) => (
              <div key={idx} className="flex items-center space-x-3">
                {step.status === "completed" ? (
                  <div className="size-6 flex items-center justify-center rounded-full bg-blue-600">
                    <div className="size-3 flex items-center justify-center rounded-full bg-white">
                      <Check className="size-2 text-blue-600" strokeWidth={3} />
                    </div>
                  </div>
                ) : (
                  <div className="size-5 flex items-center justify-center border-2 border-blue-500 text-blue-500 rounded-full text-xs font-medium">
                    {idx + 1}
                  </div>
                )}
                <span
                  className={`flex flex-col text-xs font-medium ${step.status === "completed"
                    ? "text-[#4272DD] font-medium"
                    : "text-gray-500"
                    }`}
                >
                  {step.label}
                  <span>
                    {step.date}
                  </span>
                </span>
                {idx < med?.progress?.length - 1 && (
                  <span className="w-10 border-t border-gray-300"></span>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
